import { Component, OnDestroy } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import LocalizationConstants from "src/app/constants/localization-constants";
import { Announcement } from "src/app/models/Announcement";
import { AnnouncementService } from "src/app/services/announcement.service";

@Component({
  selector: "announcement",
  templateUrl: "./announcement.component.html",
  styleUrls: ["./announcement.component.scss"],
  standalone: false,
})
export class AnnouncementComponent implements OnDestroy {
  private readonly _destroying$ = new Subject<void>();

  public localizationConstants = LocalizationConstants;
  public isAnnouncementVisible = false;
  public announcement: Announcement;

  constructor(private announcementService: AnnouncementService) {
    this.onAnnouncementChange();
  }

  private onAnnouncementChange(): void {
    this.announcementService.announcement$.pipe(takeUntil(this._destroying$)).subscribe({
      next: (announcement) => {
        this.announcement = announcement;
        this.isAnnouncementVisible = Boolean(this.announcement?.announcementId);
      },
    });
  }

  public onCloseButtonClick() {
    this.isAnnouncementVisible = false;
    // mark that it was already acknowledged and closed.
    this.announcementService.markAsSeen(this.announcement);
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
